import firebase from 'firebase/app';
import 'firebase/firestore';
import { firebaseConfig } from './config';

export const firebaseApp = firebase.initializeApp(firebaseConfig);

export const db = firebaseApp.firestore().settings({ timestampsInSnapshots: true });

export const timestamp = firebase.firestore.FieldValue.serverTimestamp();


// WEBPACK FOOTER //
// ./src/firebase/index.js